<template>
  <el-dialog
    title="选择图标"
    :visible.sync="show.is"
    width="60%"
    top="4vh"
    append-to-body
    custom-class="icon-choose-wrap"
  >
    <div class="search">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        type="text"
        v-model="icon"
        placeholder="请输入图标名称"
        @blur="searchIcons"
      ></el-input>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="elem-icons" name="elemIcon"></el-tab-pane>
      <!-- <el-tab-pane label="define-icons" name="define" v-if="showDefine"></el-tab-pane> -->
      <el-scrollbar style="height: calc(90vh - 165px)">
        <div
          class="icon"
          v-for="(item, index) of iconList"
          :key="index"
          @click="chooseIcon(item)"
        >
          <i v-if="activeName === 'elemIcon'" :class="item"></i>
          <div class="name">{{ item }}</div>
        </div>
      </el-scrollbar>
    </el-tabs>
  </el-dialog>
</template>
<script>
import elementIcons from './element-icons'
export default {
  name: 'IconPage',
  props: {
    show: {
      type: Object,
      default () {
        return { is: false }
      }
    },
    showDefine: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      icon: '',
      iconList: elementIcons,
      activeName: 'elemIcon'
    }
  },
  methods: {
    searchIcons () {
      const list = this.activeName === 'elemIcon' ? elementIcons : []
      this.iconList = list.filter(item => {
        if (item.indexOf(this.icon) > -1) {
          return item
        }
      })
    },
    chooseIcon (val) {
      this.show.is = false
      this.$emit('chooseIcon', { value: val })
    }
  },
  watch: {
    show: {
      handler (val) {
        if (val.is) {
          this.icon = ''
          this.iconList = this.activeName === 'elemIcon' ? elementIcons : []
        }
      },
      deep: true
    },
    icon (val) {
      if (!val) {
        this.iconList = this.activeName === 'elemIcon' ? elementIcons : []
      }
    }
  }
}
</script>
<style lang="stylus">
.icon-choose-wrap {
  border-radius: 8px;
  margin-bottom: 0;
  max-height: 90vh;
  overflow: hidden;
  box-sizing: border-box;

  .el-dialog__body {
    margin: 10px 20px 20px 20px;
    padding: 0;
  }

  .search {
    width: 30%;
    margin-bottom: 15px;
  }

  .icon {
    display: inline-flex;
    flex-flow: column wrap;
    justify-content: space-around;
    align-items: center;
    list-style-type: none;
    text-align: center;
    font-size: 14px;
    width: 16.66%;
    box-sizing: border-box;
    height: 108px;
    padding: 15px 6px 6px 6px;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      background: #f2f2f2;
    }

    & > i, & > svg {
      font-size: 30px;
      color: #24292e;
      cursor: pointer;
    }
  }
}
</style>
